export const projectDropdownI18nPl = {
    projects: "Projekty",
    findProjectPlaceholder: "Znajdź projekt",
    addNewProject: "Dodaj nowy projekt",
};
